/*
 * IDRAK Subscription System Marker (2026-09-22)
 *
 * Purpose: the active Functions Creator discount uses Attribute input and reads
 * one shared line-item property key: _idrak_system. To let the discount exclude
 * subscription lines from one-time quantity thresholds without changing the
 * Function input type, every cart-add request that contains a selling_plan is
 * tagged with properties[_idrak_system] = "subscription".
 *
 * One-time behavior:
 * - Official System lines remain tagged by their existing add paths as
 *   executive / active_years / glow_balance.
 * - Ordinary one-time lines stay unmarked.
 *
 * Safety:
 * - The marker is derived from the actual cart-add request body on every call.
 * - No persistent hidden form field is injected, avoiding stale state when a
 *   shopper switches between subscription and one-time on the same PDP.
 * - If a request contains selling_plan, "subscription" intentionally wins over
 *   any stale/conflicting _idrak_system value so a recurring line cannot receive
 *   an official-System or one-time quantity discount.
 * - Fail-open: tagging errors never block the real add-to-cart request.
 */
(function () {
  if (window.__idrakSubscriptionSystemGuardV1) return;
  window.__idrakSubscriptionSystemGuardV1 = true;

  var ADD_PATH_RE = /\/cart\/add(\.js)?(\?|$)/;
  var PROP_KEY = 'properties[_idrak_system]';

  function isAddUrl(u) {
    try {
      if (!u) return false;
      var s = String(u);
      var path = s;
      try {
        path = new URL(s, window.location.href).pathname;
      } catch (e) {}
      return ADD_PATH_RE.test(path) || ADD_PATH_RE.test(s);
    } catch (e) {
      return false;
    }
  }

  function hasSellingPlan(value) {
    return value !== null && value !== undefined && String(value).trim() !== '';
  }

  function tagFormData(fd) {
    try {
      if (hasSellingPlan(fd.get('selling_plan'))) {
        if (typeof fd.set === 'function') fd.set(PROP_KEY, 'subscription');
        else {
          fd.delete(PROP_KEY);
          fd.append(PROP_KEY, 'subscription');
        }
      }
    } catch (e) {}
    return fd;
  }

  function tagSearchParams(params) {
    try {
      if (hasSellingPlan(params.get('selling_plan'))) {
        params.set(PROP_KEY, 'subscription');
      }
    } catch (e) {}
    return params;
  }

  function tagItem(item) {
    if (!item || typeof item !== 'object') return item;
    if (hasSellingPlan(item.selling_plan)) {
      item.properties = item.properties || {};
      item.properties._idrak_system = 'subscription';
    }
    return item;
  }

  function tagJsonBody(text) {
    try {
      var data = JSON.parse(text);
      if (data && Array.isArray(data.items)) {
        data.items = data.items.map(tagItem);
        return JSON.stringify(data);
      }
      if (data && Object.prototype.hasOwnProperty.call(data, 'id')) {
        return JSON.stringify(tagItem(data));
      }
    } catch (e) {}
    return text;
  }

  function tagBody(body) {
    try {
      if (!body) return body;
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        return tagFormData(body);
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        return tagSearchParams(body);
      }
      if (typeof body === 'string') {
        return tagJsonBody(body);
      }
    } catch (e) {}
    return body;
  }

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : input && input.url;
        if (isAddUrl(url) && init && init.body) {
          init.body = tagBody(init.body);
        }
      } catch (e) {}
      return origFetch.apply(this, arguments);
    };
  }

  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        this.__idrakIsAdd = isAddUrl(url);
      } catch (e) {}
      return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      try {
        if (this.__idrakIsAdd && body) body = tagBody(body);
      } catch (e) {}
      return origSend.call(this, body);
    };
  }
})();
